import colors from "vuetify/es5/util/colors";
import { ThemeOptions } from "vuetify/types/services/theme";

export const nisaTheme: ThemeOptions = {
  themes: {
    light: {
      primary: "#243188",
      secondary: "#FFC72C",
      accent: "#FF4141",
      error: colors.pink.base,
      warning: colors.yellow.base,
      info: colors.blue.base,
      success: colors.lightGreen.base,
    },
  },
};
